// extracted by mini-css-extract-plugin
export default {"filter":"Filter_filter__QkIjb","title":"Filter_title__dujJS"};